import React from 'react'
import styled from 'styled-components'
import I18n from '../lib/i18n'

const StyledBanner = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  padding: 17px 4px;
  background-color: #ffc107;
  color: black;
  font-family: 'ABChanel PB Regular L', Arial, sans-serif;
  font-size: 8px;
  line-height: 1.2em;
  text-align: center;
  -webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

  html[lang=tw] & {
    font-size: 12px;
  }
`

class OfflineBanner extends React.Component {
  state = {
    offline: false
  }
  componentDidMount() {
    window.addEventListener('offline', this._updateConnectionStatus)
    window.addEventListener('online', this._updateConnectionStatus)
    this._updateConnectionStatus()
  }

  componentWillUnmount() {
    window.removeEventListener('offline', this._updateConnectionStatus)
    window.removeEventListener('online', this._updateConnectionStatus)
  }

  _updateConnectionStatus = () => {
    if (typeof navigator.onLine === 'boolean') {
      this.setState({ offline: !navigator.onLine })
    }
  }

  render() {
    return this.state.offline && <StyledBanner>{I18n.t('offline_message')}</StyledBanner>
  }
}

export default OfflineBanner



// WEBPACK FOOTER //
// ./src/components/OfflineBanner.js